import type { Room } from "matrix-js-sdk";

/**
 * Видео ли активный звонок в этой комнате (MSC4075 "m.call.intent").
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ МОДУЛЬ: одно и то же нужно в двух местах — баннеру
 * входящего (показать «видеозвонок») и кнопке «Присоединиться» (войти с
 * камерой). Держать логику в useIncomingCall нельзя: RoomView импортировал
 * бы хук ради чистой функции, а useIncomingCall уже тянет managerFor из
 * matrix/rtc — получился бы цикл импортов.
 *
 * Баг Антона 16:06: «видео уходит только от звонящего, от других участников
 * не приходит». Причина не в подписке на треки, а в том, что отвечающий
 * входил через «Присоединиться» = аудиовход, и камеру не публиковал вообще.
 * Единственным входом с видео была кнопка 📹. Теперь ответ на ВИДЕОзвонок
 * тоже идёт с видео — как в любом нормальном мессенджере.
 */
export function activeCallIsVideo(room: Room): boolean {
  let isVideo = false;
  let latestTs = 0;
  for (const ev of room.getLiveTimeline().getEvents().slice(-40)) {
    if (ev.getType() !== "org.matrix.msc4075.rtc.notification") continue;
    const content = ev.getContent();
    const lifetime = (content.lifetime as number) ?? 0;
    const senderTs = (content.sender_ts as number) ?? ev.getTs();
    if (Date.now() > senderTs + lifetime) continue; // протухло
    if (senderTs < latestTs) continue;
    latestTs = senderTs;
    isVideo = content["m.call.intent"] === "video";
  }
  return isVideo;
}
